// Plain-language explanations shown next to each merchant setting. Addressed to support and QA:
// what the setting does and what it changes for the merchant, without implementation details.
export type MerchantSettingKey =
  | 'activeCurrency'
  | 'balancePolicy'
  | 'variantFallback'
  | 'depositPrecheck'
  | 'depositSupersede'
  | 'paymentPageTimeout'
  | 'matchingAutoHalt'

export const MERCHANT_SETTING_HINTS: Record<MerchantSettingKey, string> = {
  activeCurrency:
    'В какой валюте ведётся кошелёк мерчанта: новые операции идут через кошелёк этой валюты. ' +
    'Баланс и история прежнего кошелька сохраняются. Сменить нельзя, пока на текущем кошельке есть ' +
    'баланс или незавершённые операции.',
  balancePolicy:
    'Включено — выплата мерчанта не создаётся, если его баланса с учётом овердрафта не хватает. ' +
    'Выключено — выплаты создаются независимо от баланса. Овердрафт — на сколько баланс может уйти в минус.',
  variantFallback:
    'Если под сумму депозита сейчас нет подходящей выплаты, клиенту предлагают выбрать одну из близких ' +
    'сумм вместо отказа. PG — на платёжной странице, H2H — при подключении через API.',
  depositPrecheck:
    'Перед созданием депозита на платёжной странице проверяется, есть ли сейчас выплата под эту сумму. ' +
    'Нет — депозит не создаётся, мерчант сразу получает отказ. Действует, только если других провайдеров ' +
    'у мерчанта для этого метода нет; на H2H не влияет.',
  depositSupersede:
    'Когда клиент мерчанта создаёт новый депозит, его прежние незавершённые депозиты закрываются: без ' +
    'выданного реквизита — сразу, с реквизитом — когда клиент подтвердит оплату нового или через несколько ' +
    'минут. Депозиты с чеком, спором или подтверждённой оплатой не закрываются. Выключают, если один ID ' +
    'клиента у мерчанта — не один плательщик (например, касса агента).',
  paymentPageTimeout:
    'Сколько минут от создания депозита у клиента есть на оплату на платёжной странице; после этого ' +
    'незавершённый депозит закрывается. Пусто — общий таймаут 20 минут. Допустимо 1–35.',
  matchingAutoHalt:
    'Сколько разных клиентов подряд должны не оплатить депозит по выплате мерчанта, чтобы мэтчинг этой ' +
    'выплаты остановился сам. Начатые депозиты доигрывают; затем выплата закрывается на оплаченную сумму ' +
    'или отменяется, если оплат не было. Успешная оплата начинает счёт заново. Пусто — 8. Допустимо 2–50.',
}
